<template>
  <v-row justify="center">
    <v-col cols="12" sm="10" lg="6" align="center">
      <h2 class="title-underline my-5" translate>
        {{ $t(["ORDER SUMMARY"]) }}
      </h2>

      <v-alert
        v-model="errorMsgAlert"
        close-text="Close Alert"
        class="alert-text mb-5"
        color="error"
        dark
        dismissible
        ref="snackbarError"
      >
        {{ $t(errorMsg) }}
      </v-alert>

      <v-card class="card">
        <MerchandiseTable :orderCart="orderStore.newOrderItems" />

        <v-divider class="mx-5"></v-divider>

        <v-row no-gutters justify="center" align="center">
          <h2 class="my-2">{{ $t(["TOTAL"]) }}</h2>

          <h2
            v-html="
              '&nbsp;' +
              $t('Currency', {
                amount: orderStore.totalPriceAllItems.toFixed(2),
              })
            "
          />
        </v-row>
      </v-card>

      <v-card class="card text-center my-5 pb-5">
        <v-col class="py-0" align="center">
          <h4 class="my-3" translate>
            {{ $t(["OPTIONAL ADDITIONS"]) }}
          </h4>

          <v-divider class="mx-5"></v-divider>
        </v-col>

        <v-btn-toggle v-model="selection" class="my-3" group multiple>
          <v-col>
            <v-btn
              value="Registration"
              class="btn-text btn-border btn-multiline rounded mb-5"
              style="background-color: transparent"
              elevation="3"
              x-large
              block
            >
              <v-icon v-if="selection.includes('Registration')" class="pr-2">
                mdi-checkbox-marked
              </v-icon>
              <v-icon v-else class="pr-2"> mdi-checkbox-blank-outline </v-icon>
              <span class="text-wrap" translate>
                {{ $t(["Registration"]) }}
              </span>
            </v-btn>

            <v-btn
              value="Donation"
              class="btn-text btn-border btn-multiline rounded"
              style="background-color: transparent"
              elevation="3"
              x-large
              block
            >
              <v-icon v-if="selection.includes('Donation')" class="pr-2">
                mdi-checkbox-marked
              </v-icon>
              <v-icon v-else class="pr-2">mdi-checkbox-blank-outline </v-icon>
              <span class="text-wrap" translate>
                {{ $t(["Donation"]) }}
              </span>
            </v-btn>
          </v-col>
        </v-btn-toggle>

        <v-divider class="mx-5"></v-divider>

        <v-row justify="center">
          <v-form ref="newOrderForm" class="mt-5">
            <div style="width: 280px">
              <v-text-field
                :label="$t(['Phone Number'])"
                v-model="phoneNumber"
                type="tel"
                class="centered-input error-field"
                v-mask="'(###) ###-####'"
                :rules="rules.phoneNumber"
              >
              </v-text-field>
            </div>
          </v-form>
        </v-row>
      </v-card>

      <v-row justify="center" align="center">
        <v-col cols="10" sm="8" xl="4">
          <v-btn
            class="btn-text btn-multiline mb-10"
            color="primary"
            x-large
            block
            :loading="sendOrderBtnLoading"
            @click="sendNewOrder()"
          >
            <span class="text-wrap" translate>
              {{ $t(["Next: Send Order"]) }}
            </span>
          </v-btn>
          <v-btn class="btn-text" x-large block @click="$router.go(-1)">
            {{ $t(["Back"]) }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { Auth } from "aws-amplify";

import { useAuthenicationStore } from "../../store/authenication";
import { useOrderStore } from "../../store/order";

import MerchandiseTable from "@/app/components/MerchandiseTable.vue";

export default {
  name: "NewOrderSummary",
  data: () => ({
    selection: [],
    phoneNumber: "",
    errorMsgAlert: false,
    errorMsg: "",
    sendOrderBtnLoading: false,
    rules: {
      phoneNumber: [],
    },
  }),
  components: {
    MerchandiseTable,
  },
  setup() {
    const authStore = useAuthenicationStore();
    const orderStore = useOrderStore();

    return {
      authStore,
      orderStore,
    };
  },
  watch: {
    "$i18n.locale"() {
      this.$refs.newOrderForm.resetValidation();
    },
  },
  methods: {
    setFieldValidationRules() {
      this.rules.phoneNumber = [
        (v) => !!v || this.$t(["Required"]),
        (v) => (v || "").length >= 14 || this.$t(["Invalid phone number"]),
      ];
    },
    async sendNewOrder() {
      await this.setFieldValidationRules();

      this.sendOrderBtnLoading = true;

      if (this.$refs.newOrderForm.validate()) {
        try {
          await Auth.currentSession().then(async (data) => {
            await this.orderStore
              .newOrderApi(
                {
                  eventName: this.authStore.runSiteInfo.eventName,
                  type: "Merchandise",
                  status: "Pending",
                  cart: JSON.stringify(this.orderStore.newOrderItems),
                  merchTotal: this.orderStore.totalPriceAllItems,
                  selection: this.selection.flat().toString(),
                  phoneNumber: this.phoneNumber,
                  language: this.$i18n.locale,
                },
                data.idToken.jwtToken
              )
              .then((response) => {
                // console.log(response);

                if (response.success) {
                  this.orderStore.clearOrderStore();
                  localStorage.removeItem("order");

                  this.$router.replace({
                    name: "Home",
                    params: {
                      success: true,
                      message: this.$gettext(
                        "Successfully sent order form SMS"
                      ),
                    },
                  });
                } else {
                  throw response.message;
                }
              });
          });
        } catch (error) {
          this.errorMsgAlert = true;
          this.errorMsg = error.message == undefined ? error : error.message;

          this.$nextTick(() => {
            const el = this.$el.querySelector("snackbarError");
            this.$vuetify.goTo(-5, el);

            return;
          });
        }
      }

      this.sendOrderBtnLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// Remove grey overlay on unselected button
.v-btn-toggle ::v-deep .v-btn.v-btn {
  opacity: unset !important;
}

// Center error message
div ::v-deep .v-messages {
  text-align: center;
}
</style>
